import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import classNames from 'classnames';
import RadioButtonList from '../Common/RadioButtonList.jsx';
import PortfolioRebateActions from './../../actions/PortfolioRebateActions.js';
import YourDetailsStore from '../../stores/YourDetailsStore.js';
import PortfolioRebateConstants from '../../constants/PortfolioRebateConstants.js';

function getStateFromStore() {
    return {
        trusteeList: YourDetailsStore.getTrusteeList(),
        investorList: YourDetailsStore.getInvestorList()
    };
}

export default class InvestorRebateAccountOption extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getStateFromStore();
    }

    componentDidMount() {
        YourDetailsStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        YourDetailsStore.removeChangeListener(this._onChange);
    }

    componentWillUpdate(nextProps, nextState) {
        if (!this.getIsMultipleInvestor(nextState) && nextProps.linkAccountOption !== '') {
            setTimeout(function() {
                PortfolioRebateActions.updatePortfolioRebateData({ linkAccountOption: '' });
            }, 0);
        }        
    }

    getIsMultipleInvestor(state) {
        const trusteeCount = _.get(state, 'trusteeList.length', 0);
        const investorCount = _.get(state, 'investorList.length', 0);

        return trusteeCount >= 2 || investorCount >= 2;
    }

    _onChange() {
        this.setState(getStateFromStore());
    }

    handleLinkAccountOptionChange(e) {
        const value = e.target.value;
        PortfolioRebateActions.updatePortfolioRebateData({ linkAccountOption: value });
    }

    render() {
        const isHidden = this.props.hideLinkSection || !this.getIsMultipleInvestor(this.state);
        const investorOptionList = PortfolioRebateConstants.LINK_ACCOUNT_DATA;
        return (
            <div id="linkAccountSection" className={classNames('form-group', { hidden: this.props.hideLinkSection })}>
                <RadioButtonList 
                     data={investorOptionList}
                     isHidden={isHidden}
                     id="linkedAccountList"
                     handleChange={this.handleLinkAccountOptionChange}
                     label=
                     "Please nominate whose portfolio you wish this account to be included in for the purposes of the management cost rebate calculation. If no nomination is made, this account will not be linked."
                     value={this.props.linkAccountOption}/>
            </div>
        );
    }
}

InvestorRebateAccountOption.propTypes = {
    hideLinkSection: React.PropTypes.bool.isRequired,
    linkAccountOption: React.PropTypes.string
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/PortfolioRebate/InvestorRebateAccountOption.jsx